<template>
  <div class="web-panel f-body">
    <Icons />
    <LoadingBar class="loadingbar" :loading="loading" />
    <slot></slot>
  </div>
</template>

<script>
import { createComponent } from '@vue/composition-api';
import store from '@/core/store';
import { useWebPanel } from './hooks';
import webPanelVuexModule from './store';
import LoadingBar from '@sbvr/common/legacy-shared/components/LoadingBar';
import Icons from '@sbvr/common/legacy-shared/components/Icons';

export default createComponent({
  name: 'WebPanel',
  components: {
    LoadingBar,
    Icons,
  },
  props: {
    navigation: { type: Array },
    user: { type: Object },
    dropdownItems: { type: Array },
  },
  setup ({ navigation }) {
    store.registerModule('webPanel', webPanelVuexModule);
    const { loading } = useWebPanel();
    return {
      loading,
    };
  },
});
</script>

<style lang="postcss">
body.-no-scroll {
  overflow: hidden;
}
</style>
<style lang="postcss" scoped>
.web-panel {
  --zFlash: 300;
  --zModal: 250;
  --zBottomBar: 200;
  --zHeader: 200;
  --zNavMenu: calc(var(--zHeader) + 15);
  --zDarkenOverlay: calc(var(--zHeader) + 12);
  --zLoadingBar: calc(var(--zHeader) + 10);
  --zContent: 100;
  width: 100%;
  & .loadingbar {
    position: fixed;
    top: 0;
    left: 0;
  }
}
</style>
